import { CloseIcon } from '@chakra-ui/icons';
import { Button, SimpleGrid, Box } from '@chakra-ui/react';
import { InputV2, SelectV2 } from '../../Reusable';
import { TARGET_SYMBOLS } from '../../utils/constants';
import { formatNumber, generateGraphMonthOptions, generateGraphYearOptions, revertNumberOrCurrencyFormat } from '../../utils/helper';
import { FormErrorMessage } from '../Modal/Styles';


const Datapoint = ({ title, index, formik, handleRemoveDatapoint, removeTargetType = false }) => {

    return (
        <Box style={{border: "1px solid #eee", borderRadius: '20px', padding: '24px 12px'}}>
        <Box style={{width: '100%'}} display={"flex"} flexDirection={'row'} justifyContent={'space-between'}>
            <h2 style={{textAlign: 'left', display: 'inline-block'}}>{title}</h2>
            <Button onClick={handleRemoveDatapoint} style={{ background: 'transparent', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
               <CloseIcon style={{width: '12px'}} />
            </Button>
        </Box>
        <SimpleGrid key={index} columns={[1]}>
            <Box style={{ position: "relative", zIndex: 104 }} mt={2}>
            <SelectV2
                placeholder="Choose a year"
                name={`datapoints[${index}].year`}
                title="Select year"
                options={generateGraphYearOptions()}
                value={formik.values.datapoints[index]?.year}
                onChange={(option) => {
                    formik.setFieldValue(`datapoints[${index}].year`, option.value);
                }}
            />
            <FormErrorMessage>
                {formik.errors?.datapoints?.[index]?.year}
            </FormErrorMessage>
            </Box>
            <Box style={{ position: "relative", zIndex: 103 }} mt={2}>
            <SelectV2
                placeholder="Choose a month"
                name={`datapoints[${index}].month`}
                title="Select month"
                options={generateGraphMonthOptions()}
                value={formik.values.datapoints[index]?.month}
                onChange={(option) => {
                formik.setFieldValue(`datapoints[${index}].month`, option.value);
                }}
            />
            <FormErrorMessage>
                {formik.errors?.datapoints?.[index]?.month}
            </FormErrorMessage>
            </Box>
            <Box style={{ position: "relative", zIndex: 102 }} mt={2}>
            <InputV2
            title="Target"
            name={`datapoints[${index}].target`}
            restInput={{
                onChange: (e) => {
                const cleanedUpValue = revertNumberOrCurrencyFormat(
                    e.target.value
                );
                if (!isNaN(cleanedUpValue)) {
                    formik.setFieldValue(
                    `datapoints[${index}].targetValue`,
                    cleanedUpValue
                    );
                    formik.setFieldValue(
                        `datapoints[${index}].target`,
                    formatNumber(cleanedUpValue, "decimal")
                    );
                } else {
                    formik.setFieldValue(`datapoints[${index}].target`, 0);
                    formik.setFieldValue(`datapoints[${index}].targetValue`, 0);
                }
                },
            }}
            placeholder="Your target"
            value={
              !removeTargetType
                ? formik.values.progress.targetType === "PERCENTAGES"
                  ? `${formik.values.datapoints[index]?.target ?? ""}${TARGET_SYMBOLS[formik.values.progress.targetType]}`
                  : `${TARGET_SYMBOLS[formik.values.progress.targetType]}${formik.values.datapoints[index]?.target ?? ""}`
                : formik.values.datapoints[index]?.target ?? ""
            }
            />
            <FormErrorMessage>
            {formik.errors.datapoints?.[index]?.targetValue}
            </FormErrorMessage>
        </Box>
        </SimpleGrid>
        </Box>
    )
}

export default Datapoint;